import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationComponent } from './registration/registration.component';
import { MkplOnboardingComponent } from './mkpl-onboarding/mkpl-onboarding.component';
import { SignupDoneComponent } from './signup-done/signup-done.component';
import { AtlasSignupComponent } from './atlas-signup/atlas-signup.component';
import { AtlasSubscribeComponent } from './atlas-subscribe/atlas-subscribe.component';
import { AtlasCheckoutSuccessComponent } from './atlas-checkout-success/atlas-checkout-success.component';
import { AtlasCheckoutCancelComponent } from './atlas-checkout-cancel/atlas-checkout-cancel.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';

const routes: Routes = [
  {path: '', redirectTo: 'signup', pathMatch: 'full'},
  {path: 'signup', component: RegistrationComponent},
  {path: 'activate-account', component: ActivateAccountComponent},
  {path: 'atlas', component: AtlasSignupComponent},
  {path: 'atlas-signup', component: AtlasSignupComponent},
  {path: 'atlas/subscribe', component: AtlasSubscribeComponent},
  {path: 'atlas-subscribe', component: AtlasSubscribeComponent},
  {path: 'atlas/checkout/success', component: AtlasCheckoutSuccessComponent},
  {path: 'atlas/checkout/cancel', component: AtlasCheckoutCancelComponent},
  {path: 'onboard-mkpl', component: MkplOnboardingComponent},
  {path: 'thanks', component: SignupDoneComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
